import { MEETING_TYPES_FOR_REPS } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useMeetingTypesForReps() {
  return useIsFeatureEnabled(MEETING_TYPES_FOR_REPS);
}
